import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";

import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";

export class ChartViewModel extends BaseViewModel {
  constructor(updateState, showError, showSuccess, showEmpty) {
    super();
    this.updateState = updateState;
    this.showError = showError;
    this.showSuccess = showSuccess;
    this.showEmpty = showEmpty;
  }

  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getCustomers = async () => {
    var customerResponse = await this.getCustomerListByCodeTag();
    if (Format.isNotNull(customerResponse.businesses)) {
      this.updateState("customerList", customerResponse.businesses);
      this.logger.info(customerResponse.businesses);
      var customerArray = UIMap.getDropdownOptionsExtension(
        customerResponse.businesses,
        "businessName",
        "id"
      );
      this.updateState("customerOptions", customerArray);
    } else {
      this.showError("Customer", CrudlStatus.LIST);
    }
  };

  getProducts = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (Format.isNotNull(productResponse.productList)) {
      this.updateState("productList", productResponse.productList);
      this.logger.info(productResponse.productList);
    } else {
      this.showError("Product", CrudlStatus.LIST);
    }
  };

  getParts = async () => {
    var partResponse = await this.getPartListByCodeTag();
    if (Format.isNotNull(partResponse.partList)) {
      this.updateState("partList", partResponse.partList);
      this.logger.info(partResponse.partList);
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };

  getSites = async () => {
    var siteResponse = await this.getSiteListByCodeTag();
    if (Format.isNotNull(siteResponse.siteList)) {
      this.updateState("siteList", siteResponse.siteList);
      var siteArray = UIMap.getDropdownOptionsExtension(
        siteResponse.siteList,
        "siteName",
        "id"
      );
      this.updateState("siteOptions", siteArray);
      this.logger.info(siteResponse.siteList);
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };

  getCatalogues = async () => {
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (Format.isNotNull(catalogueResponse.catalogueList)) {
      this.updateState("catalogueList", catalogueResponse.catalogueList);
      var catalgoueArray = UIMap.getDropdownOptions(
        catalogueResponse.catalogueList
      );
      this.updateState("catalgoueOptions", catalgoueArray);
      this.logger.info(catalogueResponse.catalogueList);
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      this.updateState("categoryList", categoryResponse.categoryList);
      this.logger.info(categoryResponse.categoryList);
      var categoryArray = UIMap.getDropdownOptions(
        categoryResponse.categoryList
      );
      this.updateState("categoryOptions", categoryArray);
    } else {
      this.showError("Category", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (charts, apiResponse, type, externalStateValues) => {
    var updatedChartList = [];
    if (type === CrudlStatus.CREATE) {
      updatedChartList = this.reloadAfterCreate(
        charts,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedChartList = this.reloadAfterUpdate(
        charts,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedChartList = this.reloadAfterDelete(
        charts,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("chartList", updatedChartList);
  };

  reloadAfterCreate = (chartList, apiResponse, externalStateValues) => {
    if (chartList === undefined || chartList === null) {
      chartList = [];
    }
    var chartBean = externalStateValues.chartBean;
    chartBean.id = apiResponse.id;
    chartBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    chartList.push(chartBean);

    return chartList;
  };

  reloadAfterUpdate = (chartList, apiResponse, externalStateValues) => {
    var i = 0;
    chartList.forEach(e => {
      if (apiResponse.id === e.id) {
        chartList[i] = externalStateValues.chartBean;
        chartList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return chartList;
  };

  reloadAfterDelete = (chartList, apiResponse, externalStateValues) => {
    var i = 0;
    chartList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        chartList.splice(i, 1);
      }
      i++;
    });

    return chartList;
  };
  //   executeCRUDLAction = async (crudlStatus, stateVariables) => {
  //     let chartRequest = CloudService.ChartRequest.constructFromObject(
  //       stateVariables.chartBean
  //     );
  //     if (crudlStatus === CrudlStatus.CREATE) {
  //       return await this.createChart(chartRequest, stateVariables);
  //     }
  //     if (crudlStatus === CrudlStatus.UPDATE) {
  //       return await this.updateChart(chartRequest, stateVariables);
  //     }
  //     if (crudlStatus === CrudlStatus.DELETE) {
  //       return await this.deleteChart(chartRequest);
  //     }
  //   };

  //   createChart = async (chartRequest, stateVariables) => {
  //     chartRequest.codeTag = this.codeTag;
  //     chartRequest.userId = this.userId;

  //     let chartResponse = await ApiService.chartCreate(chartRequest);
  //     if (chartResponse.errorCode === 0) {
  //       this.showSuccess("Chart", CrudlStatus.CREATE);
  //     } else {
  //       this.showError("Chart", CrudlStatus.CREATE);
  //     }

  //     return chartResponse;
  //   };

  //   deleteChart = async chartRequest => {
  //     //RESET PRODUCT REQUEST
  //     var request = {};
  //     request.codeTag = this.codeTag;
  //     request.userId = this.userId;
  //     request.id = chartRequest.id;
  //     request.lastUpdatedDateTime = chartRequest.lastUpdatedDateTime;

  //     let chartResponse = await ApiService.chartDelete(request);
  //     if (chartResponse.errorCode === 0) {
  //       this.showSuccess("Chart", CrudlStatus.DELETE);
  //     } else {
  //       this.showError("Chart", CrudlStatus.DELETE);
  //     }

  //     return chartResponse;
  //   };

  //   updateChart = async (chartRequest, stateVariables) => {
  //     chartRequest.codeTag = this.codeTag;
  //     chartRequest.userId = this.userId;

  //     let chartResponse = await ApiService.chartUpdate(chartRequest);
  //     if (chartResponse.errorCode === 0) {
  //       this.showSuccess("Chart", CrudlStatus.UPDATE);
  //     } else {
  //       this.showError("Chart", CrudlStatus.UPDATE);
  //     }

  //     return chartResponse;
  //   };
}



// WEBPACK FOOTER //
// ./src/components/Statistics/ChartViewModel.js